window.addEventListener('page.init', (e) => {
    window.fbq('track', 'PageView');
    window.fbq('track', 'ViewContent');
})

window.addEventListener('customer.enquiry', (e) => {
    window.fbq('track', 'Lead');
});

window.addEventListener('customer.subscribe', (e) => {
    window.fbq('track', 'Subscribe');
});

window.addEventListener('customer.search', (e) => {
    let query = e.detail.query;
    window.fbq('track', 'Search', {
        search_string: query,
    });
})

window.addEventListener('cart.item.create', (e) => {
    let item = e.detail.item;
    window.fbq('track', 'AddToCart', {
        content_type: 'product',
        value: item.item_price * item.quantity,
        currency: 'NZD',
        contents: [{
            id: item.price.code,
            item_price: item.item_price,
            quantity: item.quantity,
            delivery_method: item.collect ? 'in_store' : 'home_delivery',
        }],
    });
})

window.addEventListener('cart.init-checkout', (e) => {
    let cart = e.detail.cart;
    window.fbq('track', 'InitiateCheckout', {
        num_items: _.get(cart, 'item_number', 0),
    });
});

window.addEventListener('cart.checkout', (e) => {
    let { cart, order } = e.detail;

    window.fbq('track', 'Purchase', {
        content_type: 'product',
        value: `${ parseFloat(order.amount_billed).toFixed(2) }`,
        currency: 'NZD',
        contents: _.map(order.items, (item) => {
            return {
                id: item.price_code,
                item_price: item.item_price,
                quantity: item.quantity,
                delivery_method: item.collect ? 'in_store' : 'home_delivery',
            }
        })
    });
})

